import { render, staticRenderFns } from "./FreightForwarders.vue?vue&type=template&id=69eeef37&"
import script from "./FreightForwarders.vue?vue&type=script&lang=js&"
export * from "./FreightForwarders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports